var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFbobs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 14.4851,
    cy: 14.2136,
    r: 14.2136,
    fill: "#54B3FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.8195 9.21315C10.8193 9.56217 10.6794 9.89683 10.4307 10.1435C10.1819 10.3902 9.84466 10.5287 9.49305 10.5285C9.14144 10.5283 8.8043 10.3895 8.5558 10.1426C8.3073 9.89566 8.16779 9.56086 8.16797 9.21183C8.16814 8.8628 8.30799 8.52814 8.55674 8.28147C8.80549 8.03479 9.14277 7.89631 9.49437 7.89648C9.84598 7.89666 10.1831 8.03548 10.4316 8.2824C10.6801 8.52932 10.8196 8.86412 10.8195 9.21315ZM10.8592 11.503H8.20774V19.7412H10.8592V11.503ZM15.0486 11.503H12.4103V19.7412H15.0221V15.4181C15.0221 13.0098 18.184 12.7861 18.184 15.4181V19.7412H20.8023V14.5232C20.8023 10.4633 16.1224 10.6147 15.0221 12.6084L15.0486 11.503Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFbobs);
export default __webpack_public_path__ + "static/media/fbobs.b42935a140dac5d81ca086667b55af58.svg";
export { ForwardRef as ReactComponent };